import React from "react";
import PropTypes from 'prop-types';
import Autocomplete from '@mui/material/Autocomplete';
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import AddIcon from "@mui/icons-material/Add";
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { withStyles } from "@mui/styles";
import Dropzone from "react-dropzone";
import { Grid } from '@mui/material';
import cloneDeep from 'lodash.clonedeep';
import { ConfirmCancelDialog } from "../ConfirmCancelDialog";
import { LanguageContext } from '../LanguageContext';
import { Diversity1 } from "@mui/icons-material";


const defaultToolbarStyles = {
    iconButton: {
    },
};


class ContentAdd extends React.Component {
    static contextType = LanguageContext;
    constructor(props) {
        super(props);

        this.state = {
            open: false,
            setOpen: false,
            jotainMuuttui: false,
            ContentId: null,
            Activity_Id: null,
            Name: null,
            Information: null,
            Data: "",
            ContentType: "",
            FileName: "",
            Modifier: null,
            Modified: null,
            activity: (Object.keys(props.lookupLists.activity).map((d) => ({ value: d, label: props.lookupLists.activity[d] })) || []),
        };
        
    }
      

    handleClearData = () => {
        this.setState({
            open: false,
            setOpen: false,
            jotainMuuttui: false,
            openAddressSearch: false,
            ContentId: null,
            Activity_Id: null,
            Name: null,
            Information: null,
            Data: null,
            ContentType: null,
            Modifier: null,
            Modified: null
        });
    }

    handleSave = () => {
        this.props.onAddNewRow({
            ContentId: 1,
            Activity_Id: this.state.Activity_Id,
            Name: this.state.Name,
            Information: this.state.Information,
            Data: this.state.Data,
            ContentType: this.state.ContentType,
            Modifier: this.state.Modifier,
            Modified: this.state.Modified
            
        });

        this.handleClearData();
    };

    closeDialog = (list) => {
        var name = 'open' + list;
        this.setState({ [name]: false })
    };

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
            jotainMuuttui: true
        });
    };

    handleClickOpen = () => {
        this.setState({
            open: true,
        });
    }

    handleListChange = (event, newValue, item) => {
        if (newValue != null) {
            this.setState({ [item]: newValue.value })
        }
        else {
            this.setState({ [item]: null })
        }
        this.setState({ jotainMuuttui: true });
    }

    handleClose = () => {
        if (this.state.jotainMuuttui) {
            this.setState({
                setOpen: true
            });
        }
        else {
            this.setState({
                open: false,
                setOpen: false
            });
        }
    }

    handleSetOpenCancel = () => {
        this.setState({
            open: true,
            setOpen: false
        });
    }

    handleFileDrop = (acceptedFiles) => {
        if (acceptedFiles.length === 0) {
            return
        }
        const file = acceptedFiles[0];
        const reader = new FileReader();
        reader.onload = () => {
            const base64 = reader.result.split(',')[1];

            this.setState({
                Data: base64,
                ContentType: file.type,
                FileName: file.name
            });
        };
        reader.readAsDataURL(file);
    }

    b64toBlob = async (b64Data, contentType) => {
        const response = await fetch(`data:${contentType};base64, ${b64Data}`);
        return await response.blob();
    }
    getLiite = async (liite) => {
        const blob = await this.b64toBlob(liite.blobdata, liite.type);
        const blobUrl = URL.createObjectURL(blob);
        window.open(blobUrl, "_blank");
    }

    render() {
        const { dictionary } = this.context;
        const { open, activity } = this.state;

        return (
            <React.Fragment>
                <Tooltip title={dictionary.Toolbar.NewRow}>
                    <IconButton onClick={this.handleClickOpen}>
                        <AddIcon />
                    </IconButton>
                </Tooltip>

                <Dialog open={open} onClose={this.handleClose}>
                    <DialogTitle>{dictionary.Content.Title}</DialogTitle>
                    <DialogContent style={{ width: "500px" }}>
                        <Box style={{ display: 'flex', paddingTop: "10px" }} >
                            <Autocomplete
                                onChange={(event, newValue) => this.handleListChange(event, newValue, 'Activity_Id')}
                                options={activity}
                                style={{ width: 400 }}
                                renderInput={(params) => <TextField  {...params} required={true} variant="standard" label={dictionary.Content.Columns[1]} />}
                            />
                        </Box>
                        <TextField
                            required
                            margin="dense"
                            label={dictionary.Content.Columns[2]}
                            type="text"
                            fullWidth
                            value={this.state.Name}
                            onChange={this.handleChange('Name')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.Content.Columns[3]}
                            type="text"
                            fullWidth
                            value={this.state.Information}
                            onChange={this.handleChange('Information')}
                        />
                        <Dropzone
                                multiple={false}
                                onDrop={this.handleFileDrop}
                         >
                                {({ getRootProps, getInputProps }) => (
                                    <div
                                        {...getRootProps()}
                                        style={{
                                            border: "2px dashed #3f51b5",
                                            borderRadius: 8,
                                            minHeight: 120,
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            cusor: "pointer"
                                        }} 
                                    >
                                        <input {...getInputProps()} />
                                        {this.state.FileName || "Drag & drop a file here or click "}
                                    </div>
                                    
                                )}
                        </Dropzone>
                        

                        <TextField
                                required
                                margin="dense"
                                label={dictionary.Content.Columns[5]}
                                type="text"
                                fullWidth
                                value={this.state.ContentType}
                                InputProps={{
                                    readOnly: true
                                }}
                            //onChange={this.handleChange('ContentType')}
                            />
                        

                            
                    </DialogContent>
                    <DialogActions
                        style={{ backgroundColor: "#3C495A" }}
                    >
                        <ButtonGroup variant="comboButton">
                            <Button variant="Secondary" onClick={this.handleClose}>
                                {dictionary.Close}
                            </Button>
                            <Button variant="Primary" onClick={this.handleSave}>
                                {dictionary.Save}
                            </Button>
                        </ButtonGroup>
                    </DialogActions>
                </Dialog>
                <ConfirmCancelDialog
                    open={this.state.setOpen}
                    onCancel={this.handleSetOpenCancel}
                    onOk={this.handleClearData}
                />
            </React.Fragment>
        );
    }
}

export default withStyles(defaultToolbarStyles, { name: "ContentAdd" })(ContentAdd);
